module.exports = __webpack_public_path__ + "static/media/blobMedium.4868bf7c.svg";